import { FC } from 'react';

import { QualityLevel } from 'vcs-common';

export interface IConnectionQualityPanelProps {
  quality: QualityLevel;
}
export const ConnectionQualityPanel: FC<IConnectionQualityPanelProps> = ({ quality }) => {
  const isPoor = quality === 'disconnected' || quality === 'poor';
  const isDegraded = quality === 'unstable';
  const color = isPoor ? 'text-red-500' : isDegraded ? 'text-yellow-300' : 'text-green-400';
  const icon = isPoor ? 'signal_cellular_alt_off' : isDegraded ? 'signal_cellular_alt_2_bar' : 'signal_cellular_alt';

  return (
    <span className={`material-symbols-outlined block leading-none ${color}`} style={{ fontSize: '24px' }} aria-hidden="true">
      {icon}
    </span>
  );

};
